import { Component, OnInit, signal, TemplateRef, ViewChild } from '@angular/core';
import { FavouriteListPayload } from 'src/app/shared/entity/utility-interfaces';
import { FavouriteListAPIModel } from 'src/app/shared/models/favourite';
import { DataAccessService } from 'src/app/shared/services/data-access/data-access.service';
import { SettingService } from '../setting.service';
import { CommonService } from 'src/app/shared/services/common/common.service';
import { AppConstants } from 'src/app/shared/entity/constants';
import { DataRepositoryService } from 'src/app/shared/services/data-repository/data-repository.service';
import { BusinessLocation } from 'src/app/shared/models/business-location-details';

@Component({
    selector: 'app-setting',
    templateUrl: './setting.component.html',
    styleUrls: ['./setting.component.scss'],
    standalone: false
})
export class SettingComponent implements OnInit {
  @ViewChild('deleteDialog') deleteDialog: TemplateRef<any>;
  @ViewChild('addNewList') addNewList: TemplateRef<any>;

  get favData(): FavouriteListAPIModel[] {
    return this.settingService.favListArray();
  }
  ingredient!: string;
  value: string = '';
  Favorites = '';
  checked = false
  displayedColumns: string[] = ['actions', 'name', 'blids', 'IsEvening'];
  readonly businessLocationsList = signal(new Map<string, BusinessLocation>());

  constructor(
    public dataAccessService: DataAccessService,
    public settingService: SettingService,
    public commonService: CommonService,
    private readonly dataRepositoryService: DataRepositoryService) { }


  ngOnInit(): void {
    if (this.dataRepositoryService.businessLocationListMap.size) {
      this.businessLocationsList.set(this.dataRepositoryService.businessLocationListMap);
    } else {
      this.dataAccessService.getBLData().subscribe(() => {
        this.businessLocationsList.set(this.dataRepositoryService.businessLocationListMap);
      });
    }
    this.getFavlistData();
  }

  addNewFavList() {
    this.settingService.formPopupVisible = true
    this.settingService.createForm();
  }

  edit(favData: any) {
    this.settingService.formPopupVisible = true
    this.settingService.setFormValue(favData);
  }

  getFavlistData() {
    this.settingService.getFavList();
  }

  submit() {
    if (this.settingService.favoriteForm.valid) {
      this.settingService.submit();
    }
  }

  deleteFavoriteList(favData: FavouriteListPayload) {
    this.commonService.showConfirmationAlert(AppConstants.DELETE_MESSAGE, AppConstants.DELETE_CONFIRMATION, () => {
      this.settingService.deleteFavList(favData);
    });
  }
}


export enum UserPreferenceEnum {
  TASK_BANK_COLUMNS = 'taskbankcolumns',
  GLOBAL_Filter_PREFERENCE = 'globleFilterPreference',
  THEME = 'theme',
  FAVORITE_LIST = 'favourite',
  COLUMNFILTER = 'columnfilter',
  USERCOLUMNPREFERENCES = 'userColumnPreferences',
  SELECTEDUSERPREFERENCES = 'selectedUserPreferences'
}